export const formRoute = `form`;
export const commitFiles = `commit-files`;
export const chooseRepoRoute = `choose-repo`;
export const summaryRoute = `summary`;
